export default {
	state: {
		complaintList: [],
		complaintDownloadList: []
	},

	getters: {

	},

	mutations: {
		setComplaintList(state, payload) {
			state.complaintList = payload;
		},
		setComplaintDownloadList(state, payload) {
			state.complaintDownloadList = payload;
		},
	},

	actions: {
		reqComplaintList( { commit }, params ) {
			return new Promise((r, j) => {
				fetch({
					url: "hcm/complaint/getComplaintNewList",
					method: "get",
					params: params,
				}).then((res) => {
					if(res.status === '10000') {
						commit('setComplaintList', res.data.content);
						r(res.data);
					}
				}).catch(() => {
					j();
				})
			})
		},
		reqComplaintDownload( { commit }, params ) {
			return new Promise((r, j) => {
				fetch(params).then((res) => {
					if(res.status === '10000') {
						commit('setComplaintList', res.data.content);
						r(res.data);
					}
				}).catch(() => {
					j();
				})
			})
		},
		reqComplaintDownloadList( { commit }, data ) {
			return new Promise((r, j) => {
				fetch({
					url: 'hcm/spider/list/libao_list',
					method: 'post',
					data: JSON.stringify(data)
				}).then((res) => {
					if(res.success === 'True') {
						this.downloadList = res.data;
						if(this.downloadList.length) {
							this.totalPage = this.downloadList[0].total;
						}
					}
					commit('setComplaintDownloadList', res.data);
					r(res.data);
				}).catch(() => {
					j();
				})
			})
		},
	},
}
